import React, { memo } from "react"
import styled, { keyframes } from "styled-components"
import Option from "./Option"
import SvgIcon from "../../zzz/atoms/icons/svg-icon"
import ArrowDown from "../../zzz/atoms/icons/files/arrow-down.jsx"
import Info from "../../zzz/atoms/icons/files/info.jsx"
import { graphql, useStaticQuery } from "gatsby"

// ======================
// 	🧱🧱 COMPONENT 🧱🧱
// ======================
const Block = memo(
  ({ title, options, toggleFilter, viewNext, filterActive, isLast, extra }) => {
    return (
      <BlockWrap>
        <BlockTop>
          <h2>{title}</h2>
          {!isLast && (
            <div onClick={viewNext}>
              skip this <SvgIcon SvgComponent={ArrowDown} />{" "}
            </div>
          )}
        </BlockTop>
        <BlockOptions>
          {options.map((option, i) => (
            <Option
              key={i}
              image={option.image}
              title={option.title}
              text={option.description}
              value={option.value}
              link={option.link}
              toggleFilter={toggleFilter(option.value)}
              filterActive={filterActive(option.value)}
            />
          ))}
        </BlockOptions>
        {extra && (
          <Extra>
            <SvgIcon SvgComponent={Info} hue="tusk" shade="100" />
            <span>{extra}</span>
          </Extra>
        )}
      </BlockWrap>
    )
  }
)

// ====================
// 	💅🏼💅🏼 STYLES 💅🏼💅🏼
// ====================

const Extra = styled.div`
  margin-top: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #77848e;
`

const BlockWrap = styled.div`
  background: white;
  box-shadow: 0 10px 15px -7px rgba(119, 132, 142, 0.19);
  margin-bottom: 30px;
  padding: 30px;
`
const bounce = keyframes`
0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
    40% {transform: translateY(-5px);}
    60% {transform: translateY(-3px);}
`

const BlockTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  h2 {
    font-size: 20px;
    color: #223247;
    font-weight: 500;
  }
  div {
    font-size: 13px;
    color: #3e4b5c;
    text-transform: uppercase;
    cursor: pointer;

    > span.icon {
      animation: none;
    }

    &:hover {
      > span.icon {
        animation: ${bounce} 1s infinite;
      }
    }
  }
`
const BlockOptions = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;

  @media (max-width: ${({ theme }) => theme.breakMedium}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakTiny}) {
    grid-template-columns: repeat(1, 1fr);
  }
  h3 {
    font-size: 20px;
    display: flex;
    justify-content: space-between;
  }
  p {
    margin-top: 10px;
  }
`
export default Block
